import vue2Dropzone from "vue2-dropzone";
import { upload } from "@/fileupload";

export default {
  components: {
    vueDropzone: vue2Dropzone,
  },
  data: () => ({
    form: {
      name: null,
      description: null,
      abbreviation: null,
      logo: null,
      url: null,
    },
    logoUploadError: null,
    logoUploading: false,
    dropzoneOptions: {
      url: "https://httpbin.org/post",
      thumbnailWidth: 192,
      maxFilesize: 50,
      maxFiles: 1,
      headers: { "My-Awesome-Header": "header value" },
      autoDiscover: false,
      autoProcessQueue: false,
      autoQueue: false,
      acceptedFiles: "image/*",
      init: function () {
        this.on("addedfile", function () {
          if (this.files[1] != null) {
            this.removeFile(this.files[0]);
          }
        });
      },
    },
  }),

  methods: {
    async fileAdded(files) {
      const file = files[0];
      if (!file) {
        return;
      }

      this.logoUploadError = null;
      this.logoUploading = true;

      try {
        this.form.logo = await upload(file);
        if (this.$v && this.$v.form && this.$v.form.logo) {
          this.$v.form.logo.$touch();
        }
      } catch (e) {
        this.logoUploadError =
          (e && e.message) ||
          "Logo upload failed. Check the storage SAS and try again.";
        this.$notify({
          text: this.logoUploadError,
          type: "error",
        });
        if (this.$refs.dropzone) {
          this.$refs.dropzone.removeAllFiles();
        }
      } finally {
        this.logoUploading = false;
      }
    },
  },
};
